var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bmain"},[(_vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_c('div',{class:_vm.calculatedclass},[_vm._t("default")],2)]):_c('div',{class:_vm.calculatedclass,on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }